var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":"Title"}},[_c('b-input',{attrs:{"placeholder":"e.g Say hello"},model:{value:(_vm.content.title),callback:function ($$v) {_vm.$set(_vm.content, "title", $$v)},expression:"content.title"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }